import React from 'react'

import { useCreateAuthToken } from '@/app/module/user/hooks/use-create-authtoken'
import { useDeleteAuthToken } from '@/app/module/user/hooks/use-delete-authtoken'
import { useGetAuthTokens } from '@/app/module/user/hooks/use-get-authtokens'
import { useUpdateAuthToken } from '@/app/module/user/hooks/use-update-authtoken'
import { APIKey, UpdateAPIKeyPayload } from '@/app/module/user/types'

import ApiKeys from './api-keys'

type Props = {}

const ApiKeysContainer: React.FC<Props> = () => {
  const { data, isFetching, refetch } = useGetAuthTokens()
  const [createToken, { isLoading: isCreating }] = useCreateAuthToken()
  const [updateToken, { isLoading: isUpdating }] = useUpdateAuthToken()
  const [deleteToken, { isLoading: isDeleting }] = useDeleteAuthToken()

  const apiKeys = (data?.tokens || []) as APIKey[]
  const loading = isFetching || isCreating || isUpdating || isDeleting

  const getKeys = React.useCallback(async () => {
    await refetch()
  }, [refetch])

  const createAPIKey = React.useCallback(async () => {
    await createToken()
  }, [createToken])

  const deleteAPIKey = React.useCallback(
    async (tokenId: number) => {
      await deleteToken(tokenId)
    },
    [deleteToken],
  )

  const updateAPIKey = React.useCallback(
    async (tokenId: number, item: UpdateAPIKeyPayload) => {
      await updateToken(tokenId, item)
    },
    [updateToken],
  )

  return (
    <ApiKeys
      apiKeys={apiKeys}
      loading={loading}
      onCreate={createAPIKey}
      onDelete={deleteAPIKey}
      onEdit={updateAPIKey}
      onRefresh={getKeys}
    />
  )
}

export default ApiKeysContainer
